"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeOfPlaygroundPropertyOption = exports.isTypeOfPlaygroundProperty = exports.typeOfPlaygroundPropertyDefinition = void 0;
const typeOfPlaygroundPropertyOptions = ['playground', 'playground-project'];
exports.typeOfPlaygroundPropertyDefinition = {
    view: { label: 'Subtype' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'options',
            argument: typeOfPlaygroundPropertyOptions,
        },
    ],
    default: 'playground',
    type: 'select',
    multiple: false,
    name: 'type-of-playground',
};
const isTypeOfPlaygroundProperty = (prop) => {
    return prop.name === exports.typeOfPlaygroundPropertyDefinition.name;
};
exports.isTypeOfPlaygroundProperty = isTypeOfPlaygroundProperty;
const isTypeOfPlaygroundPropertyOption = (option) => {
    return typeOfPlaygroundPropertyOptions.includes(option);
};
exports.isTypeOfPlaygroundPropertyOption = isTypeOfPlaygroundPropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZS1vZi1wbGF5Z3JvdW5kLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdHlwZS1vZi1wbGF5Z3JvdW5kLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLE1BQU0sK0JBQStCLEdBQUcsQ0FBQyxZQUFZLEVBQUUsb0JBQW9CLENBQVUsQ0FBQTtBQUV4RSxRQUFBLGtDQUFrQyxHQUFHO0lBQ2hELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUU7SUFDMUIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsU0FBUztZQUNmLFFBQVEsRUFBRSwrQkFBK0I7U0FDMUM7S0FDRjtJQUNELE9BQU8sRUFBRSxZQUFZO0lBQ3JCLElBQUksRUFBRSxRQUFRO0lBQ2QsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsb0JBQW9CO0NBQ0ssQ0FBQTtBQUkxQixNQUFNLDBCQUEwQixHQUFHLENBQUMsSUFBa0IsRUFBb0MsRUFBRTtJQUNqRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssMENBQWtDLENBQUMsSUFBSSxDQUFBO0FBQzlELENBQUMsQ0FBQTtBQUZZLFFBQUEsMEJBQTBCLDhCQUV0QztBQUlNLE1BQU0sZ0NBQWdDLEdBQUcsQ0FBQyxNQUFjLEVBQTRDLEVBQUU7SUFDM0csT0FBUSwrQkFBcUQsQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDLENBQUE7QUFDaEYsQ0FBQyxDQUFBO0FBRlksUUFBQSxnQ0FBZ0Msb0NBRTVDIn0=